export class RepairError extends Error {
    constructor(context, type, value, message) {
        super(message);
        this.context = context;
        this.type = type;
        this.value = value;
    }
}
